import { css } from "styled-components";
export const colorsTokens = {
    // BLUE
    "--blue-50": "#eff4ff",
    "--blue-100": "#dbe6fe",
    "--blue-200": "#bfd3fe",
    "--blue-300": "#93b4fd",
    "--blue-400": "#6090fa",
    "--blue-500": "#3b76f6",
    "--blue-600": "#2563eb",
    "--blue-700": "#1d58d8",
    "--blue-800": "#1e4baf",
    "--blue-900": "#1e408a",
    "--blue-950": "#172a54",
    // FUCHSIA
    "--fuchsia-50": "#fef4ff",
    "--fuchsia-100": "#fce8ff",
    "--fuchsia-200": "#f8d0fe",
    "--fuchsia-300": "#f1abfc",
    "--fuchsia-400": "#e879f9",
    "--fuchsia-500": "#d946ef",
    "--fuchsia-600": "#bc26d3",
    "--fuchsia-700": "#9c1caf",
    "--fuchsia-800": "#80198f",
    "--fuchsia-900": "#691a75",
    "--fuchsia-950": "#44044e",
    // GREEN
    "--green-50": "#effef3",
    "--green-100": "#dafee3",
    "--green-200": "#b6fcc9",
    "--green-300": "#7ef79f",
    "--green-400": "#3fe96e",
    "--green-500": "#15d24a",
    "--green-600": "#0bae38",
    "--green-700": "#0c802d",
    "--green-800": "#106b2b",
    "--green-900": "#0f5825",
    "--green-950": "#023111",
    // GREYS
    "--greys-50": "#f6f6f6",
    "--greys-100": "#e7e7e7",
    "--greys-200": "#d1d1d1",
    "--greys-300": "#b0b0b0",
    "--greys-400": "#888888",
    "--greys-500": "#6d6d6d",
    "--greys-600": "#5d5d5d",
    "--greys-700": "#4f4f4f",
    "--greys-800": "#444444",
    "--greys-900": "#3d3d3d",
    "--greys-950": "#262626",
    "--greys-950-10": "rgba(38, 38, 38, 0.1)",
    "--greys-950-15": "rgba(38, 38, 38, 0.15)",
    "--greys-950-50": "rgba(38, 38, 38, 0.50)",
    "--greys-950-80": "rgba(38, 38, 38, 0.80)",
    "--greys-white": "#ffffff",
    // HYPERA BLUE
    "--hypera-blue-50": "#f0f8ff",
    "--hypera-blue-100": "#dff0ff",
    "--hypera-blue-200": "#b9e1fe",
    "--hypera-blue-300": "#7bcbfe",
    "--hypera-blue-400": "#34b0fc",
    "--hypera-blue-500": "#0a97ed",
    "--hypera-blue-600": "#0077cb",
    "--hypera-blue-700": "#0062aa",
    "--hypera-blue-800": "#055187",
    "--hypera-blue-900": "#0a4370",
    "--hypera-blue-950": "#072a4a",
    // ORANGE
    "--orange-50": "#fff6ed",
    "--orange-100": "#ffebd5",
    "--orange-200": "#fed2aa",
    "--orange-300": "#fdb274",
    "--orange-400": "#fb873c",
    "--orange-500": "#f96515",
    "--orange-600": "#ea4b0c",
    "--orange-700": "#c2360c",
    "--orange-800": "#9a2c12",
    "--orange-900": "#7c2712",
    "--orange-950": "#431007",
    // RED
    "--red-50": "#fff1f2",
    "--red-100": "#ffe0e3",
    "--red-200": "#ffc7cd",
    "--red-300": "#ffa0aa",
    "--red-400": "#ff6978",
    "--red-500": "#fa394d",
    "--red-600": "#e71b30",
    "--red-700": "#c31224",
    "--red-800": "#a81423",
    "--red-900": "#851722",
    "--red-950": "#49060d",
    // TEAL
    "--teal-50": "#ecfdf7",
    "--teal-100": "#d1faec",
    "--teal-200": "#a7f3da",
    "--teal-300": "#6ee7bf",
    "--teal-400": "#34d39e",
    "--teal-500": "#10b981",
    "--teal-600": "#059666",
    "--teal-700": "#047852",
    "--teal-800": "#065f42",
    "--teal-900": "#064e36",
    "--teal-950": "#022c1e",
};
export const aliasesTokens = {
    /* SURFACE */
    "--surface-primary": "var(--greys-50)",
    "--surface-accent": "var(--hypera-blue-600)",
    "--surface-white": "var(--greys-white)",
    "--surface-accent-light": "var(--hypera-blue-100)",
    "--surface-accent-dark": "var(--hypera-blue-800)",
    /* NEUTRALS */
    "--neutral-white": "var(--greys-white)",
    "--neutral-black": "var(--greys-950)",
    /* OVERLAYS */
    "--neutral-black-10": "var(--greys-950-10)",
    "--neutral-black-15": "var(--greys-950-15)",
    "--neutral-black-50": "var(--greys-950-50)",
    /* SEMANTIC BASE */
    "--semantic-info-base": "var(--hypera-blue-500)",
    "--semantic-warning-base": "var(--orange-500)",
    "--semantic-success-base": "var(--green-700)",
    "--semantic-error-base": "var(--red-600)",
    "--semantic-progress-base": "var(--blue-500)",
    "--semantic-disable-base": "var(--greys-600)",
    "--semantic-promo-base": "var(--green-500)",
    /* SEMANTIC WEAK */
    "--semantic-info-weak": "var(--hypera-blue-200)",
    "--semantic-warning-weak": "var(--orange-100)",
    "--semantic-success-weak-light": "var(--green-50)",
    "--semantic-success-weak": "var(--green-200)",
    "--semantic-error-weak": "var(--red-100)",
    "--semantic-progress-weak": "var(--blue-200)",
    "--semantic-disable-weak": "var(--greys-100)",
    "--semantic-promo-weak": "var(--green-500)",
    /* SEMANTIC TEXT */
    "--semantic-info-text": "var(--hypera-blue-900)",
    "--semantic-warning-text": "var(--orange-800)",
    "--semantic-success-text": "var(--green-900)",
    "--semantic-error-text": "var(--red-900)",
    "--semantic-progress-text": "var(--blue-950)",
    "--semantic-disable-text": "var(--greys-300)",
    "--semantic-promo-text": "var(--green-600)",
    "--semantic-campaign-limited-text": "var(--fuchsia-800)",
    /* TEXT */
    "--text-primary": "var(--greys-950)",
    "--text-secondary": "var(--greys-500)",
    "--text-invert": "var(--greys-50)",
    "--text-disable": "var(--greys-300)",
    "--text-link": "var(--hypera-blue-600)",
    /* BORDERS */
    "--border-primary": "var(--greys-200)",
    "--border-active": "var(--hypera-blue-600)",
    "--border-disable": "var(--greys-100)",
    "--border-error": "var(--red-800)",
    // ? Essas cores não serão alteradas por enquanto, manter do jeito que está.
    // BONI
    "--mine-shaft200": "#D1D1D1",
    "--boni-purple": "#e7d8fc",
    "--boni-purple700": "#782EC5",
    "--brand-fidelity100": "#4E5389",
    "--amber950": "#482200",
    "--spring-green700": "#03925E",
    "--electric-violet500": "#724CF9",
    "--royal-blue500": "#4361EE",
    "--seagull600": "#0B8DBE",
    "--seagull400": "#4cc9f0",
    // NEO QUIMICA
    "--brand-neoQuimica": "#035C7E",
};
const generateCssVariables = (colorsToken) => {
    let cssVariables = "";
    Object.entries(colorsToken).forEach(([key, value]) => {
        cssVariables += `  ${key}: ${value};\n`;
    });
    return cssVariables;
};
export const colorsTokenCSS = css `
	:root {
		/* COLORS TOKENS */
		${generateCssVariables(colorsTokens)}

		/* ALIASES TOKENS */
		${generateCssVariables(aliasesTokens)}
	}
`;
//# sourceMappingURL=colors.js.map